





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CheckBox extends Vue {
  @Prop({ default: "" }) readonly label!: string | boolean;
  @Prop({ default: false, required: true }) readonly checked!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: "" }) readonly tooltip!: string | Array<any>;
  @Prop({ default: "right" }) readonly tooltipPosition!: string;

  private check = false;
  private randomid = "";

  created() {
    this.randomid = Math.random().toString(36);
    this.check = this.checked;
  }

  @Watch("checked")
  checkedChanged(newVal: boolean) {
    this.check = newVal;
  }
}
